import { BaseBillingEntity } from '/@/modules/billing/models/BaseBillingEntity';
import NumeralService from '/@/modules/core/app/services/NumeralService';
import { ColumnFormat } from '/@/modules/core/app/constants/data.constants';

export class BillingCoupon extends BaseBillingEntity {
  /**
   * @var {string}
   */
  addonConstraint;

  /**
   * @var {string}
   */
  applyDiscountOn;

  /**
   * @var {string}
   */
  applyOn;

  /**
   * @var {number}
   */
  appliedCount;

  /**
   * @var {string}
   */
  couponId;

  /**
   * @var {number}
   */
  createdAt;

  /**
   * @var {string}
   */
  discountType;

  /**
   * @var {number}
   */
  discountAmount;

  /**
   * @var {string}
   */
  durationType;

  /**
   * @var {string}
   */
  id;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  object;

  /**
   * @var {string}
   */
  planConstraint;

  /**
   * @var {number}
   */
  redemptions;

  /**
   * @var {string}
   */
  status;

  constructor(model = {}) {
    super(model);

    this.addonConstraint = model.addonConstraint;
    this.applyDiscountOn = model.applyDiscountOn;
    this.appliedCount = model.appliedCount;
    this.applyOn = model.applyOn;
    this.createdAt = model.createdAt;
    this.couponId = model.couponId;
    this.discountType = model.discountType;
    this.discountAmount = model.discountAmount;
    this.durationType = model.durationType;
    this.id = model.id;
    this.name = model.name;
    this.object = model.object;
    this.planConstraint = model.planConstraint;
    this.redemptions = model.redemptions;
    this.status = model.status;
  }

  get displayDiscountAmount() {
    return NumeralService.formatValue(this.discountAmount, ColumnFormat.FORMAT_CURRENCY);
  }
}
